export default __webpack_public_path__ + "static/carousell-autos-logo-c7d9e9ebf833a0d837511a2639fd727e.png";